import React, { createContext, useContext, useState, useRef } from 'react';

const OnboardingSetupContext = createContext(null);

export const OnboardingSetupProvider = ({ children }) => {
  const [showSetupModal, setShowSetupModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [brandType, setBrandType] = useState('');
  const [logoPreview, setLogoPreview] = useState(null);
  const [brandCreated, setBrandCreated] = useState(false);
  const [aiSuggestions, setAiSuggestions] = useState({});
  const fileInputRef = useRef(null);

  const openSetupModal = ({
    formData: fd,
    brandType: bt,
    logoPreview: lp,
    brandCreated: bc,
    aiSuggestions: ai,
  }) => {
    setFormData(fd);
    setBrandType(bt);
    setLogoPreview(lp);
    setBrandCreated(bc);
    setAiSuggestions(ai || {});
    setShowSetupModal(true);
  };

  const closeSetupModal = () => {
    setShowSetupModal(false);
  };

  return (
    <OnboardingSetupContext.Provider
      value={{
        showSetupModal,
        formData,
        setFormData,
        brandType,
        logoPreview,
        setLogoPreview,
        brandCreated,
        setBrandCreated,
        aiSuggestions,
        fileInputRef,
        openSetupModal,
        closeSetupModal,
      }}
    >
      {children}
    </OnboardingSetupContext.Provider>
  );
};

export const useOnboardingSetup = () => {
  const context = useContext(OnboardingSetupContext);
  if (!context) {
    return { showSetupModal: false };
  }
  return context;
};
